import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import Signup from '../Signup/SignupPage';
import { useLocation } from 'react-router-dom';

const LoginPage = () => {

  const location = useLocation();
  const { signupActive } = location.state || {}; 

  const [isMobileView, setIsMobileView] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false); // Controls form change
  const [showText, setShowText] = useState(false); // Controls text change


  const [isSignupActive, setIsSignupActive] = useState(false);
  useEffect(() => {
    if (signupActive) {
      setIsSignupActive(true);
      setShowSignUp(true)
      setShowText(true)
    }
  }, [signupActive]);

  // Function to toggle the right panel state (Signup/Login)
  const handleSignUpClick = () => {
    setIsSignupActive(true);
    setTimeout(() => {
      setShowSignUp(true);  // Delay the form switch
      setShowText(true);    // Delay the text switch
    }, 300); // Wait for the transition duration (500ms)
  };

  const handleSignInClick = () => {
    setIsSignupActive(false);
    setTimeout(() => {
      setShowSignUp(false);  // Delay the form switch
      setShowText(false);    // Delay the text switch
    }, 300); // Wait for the transition duration (500ms)
  };

  // Function to detect window resizing and update the isMobileView state
  const updateViewMode = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  useEffect(() => {
    updateViewMode(); // Set initial view mode based on the current window size
    window.addEventListener('resize', updateViewMode); // Update on resize
    return () => window.removeEventListener('resize', updateViewMode); // Cleanup listener
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#e4e8ea]">
      {/* Container for both mobile and desktop views */}
      <div className=" w-full max-w-full max-h-screen bg-[#e4e8ea] shadow-lg overflow-y-scroll flex flex-col md:flex-row h-full md:h-auto">
        {/* Form Section (Login / Signup) */}
        <div
          className={`${isMobileView 
            ? `relative flex-1 w-full transition-transform `
            : `inset-0 left-1/2 h-full w-1/2 bg-gradient-to-r from-[var(--color-fill)] to-[var(--color-contrast)] transition-transform duration-700 ease-in-out z-30 flex justify-center items-center ${isSignupActive ? 'translate-x-0 opacity-100 z-20' : 'translate-x-full opacity-100 z-10'}`}`
          }
        >
          <div className={`w-full min-h-screen flex flex-col justify-center items-center p-4 md:p-8 lg:p-12 ${isMobileView ? 'bg-gradient-to-r from-[var(--color-fill)] to-[var(--color-contrast)]' : 'bg-[#e4e8ea]'}`}>
            {/* Set maximum width for forms on larger screens */}
            <div className="w-full max-w-md md:max-w-lg lg:max-w-xl flex flex-col justify-center items-center">
              {isSignupActive && showSignUp ? <Signup /> : <LoginForm />}
            </div>
          </div>
        </div>

        {/* Desktop View - Overlay Section */}
        {!isMobileView && (
          <div
            className={`hidden md:flex absolute inset-0 md:left-1/2 w-1/2 h-full bg-gradient-to-r from-[var(--color-fill)] to-[var(--color-contrast)] transition-transform duration-700 ease-in-out z-30 justify-center items-center ${
              isSignupActive ? 'translate-x-0' : '-translate-x-full'
            }`}
          >
            <div className="text-white flex flex-col justify-center items-center p-10 font-custom">
              <h1 className="text-3xl md:text-4xl font-bold mb-4">
                {isSignupActive && showText ? 'Hello, Friend!' : 'Welcome Back!'}
              </h1>
              <p className="text-sm md:text-base mb-6">
                {isSignupActive && showText
                  ? 'Enter your personal details and start your journey with us'
                  : 'To keep connected with us please login with your personal info'}
              </p>
              <button
                onClick={isSignupActive ? handleSignInClick : handleSignUpClick}
                className="bg-transparent border border-white text-white py-2 px-8 rounded-full"
              >
                {isSignupActive ? 'Sign In' : 'Sign Up'}
              </button>
            </div>
          </div>
        )}

        {/* Mobile View - Hemisphere Button */}
        {isMobileView && (
  <div className=" md:hidden fixed top-1/3 right-0 z-50">
    <div
      className="bg-gradient-to-r from-[var(--color-fill)] to-[var(--color-contrast)] shadow-lg py-2 px-4 text-white rounded-l-lg cursor-pointer transition-transform duration-500"
      onClick={isSignupActive ? handleSignInClick : handleSignUpClick}
    >
      {isSignupActive ? 'Sign In' : 'Sign Up'}
    </div>
  </div>
)}

      </div>
    </div>
  );
};

export default LoginPage;
